module.exports = __webpack_public_path__ + "static/media/empty.61f13345.svg";